var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stats)?_c('span',[_vm._v("\n\tGEB: "+_vm._s(_vm.legibleStatistics.closeValue)+"\n\t"),_c('span',{staticClass:"text-geb-bahia"},[_vm._v(" "+_vm._s(_vm.legibleStatistics.increaseInPercentage))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }